(function() {
  'use strict';

  angular.module('eclipseApp.checkout').controller('buyReviewCtrl', [
    '$rootScope',
    '$scope',
    '$http',
    'uteEndpoint',
    '$state',
    'uteSemafoneService',
    'uteModal',
    'buyService',
    'notifier',
    'orderSummary',
    'cartManager',
    'buyUtils',
    'dtmService',
    'dtmServiceConstants',
    '$timeout',
    'commonService',
    'brtEndpoint',
    'uteLocale',
    'brtSwitchCMS',
    'internetPackageService',
    'ute.datalayer.common.service',
    function(
      $rootScope,
      $scope,
      $http,
      uteEndpoint,
      $state,
      uteSemafoneService,
      uteModal,
      buyService,
      notifier,
      orderSummary,
      cartManager,
      buyUtils,
      dtmService,
      dtmServiceConstants,
      $timeout,
      commonService,
      brtEndpoint,
      uteLocale,
      brtSwitchCMS,
      internetPackageService,
      dataLayerService
    ) {
      $scope.acknowledge = false;

      $scope.isHybridFlow = brtSwitchCMS.brtSwitch.isHybridFlow;

      $scope.accepted = function() {
        angular.element('.ute-input-textarea').bind('scroll', function() {
          var offset = $('.read-only').offset().top + $('.read-only').height();
          var top = $('.read-only div').offset().top + $('.read-only div').height() - offset;

          if (top <= 100 && $scope.acknowledge == false) {
            $scope.$apply(function() {
              //$scope.acknowledge = true;
            });
          }
        });

        $scope.clicked = true;

        var offset = $('.read-only').offset().top + $('.read-only').height();
        var top = $('.read-only div').offset().top + $('.read-only div').height() - offset;

        if (top <= 100 && $scope.acknowledge == false) {
          $scope.acknowledge = true;
        }
        if ($scope.acknowledge == false) {
          $('#tos_consent').prop('checked', false);
          $scope.review.tos_consent = false;
        }
        if ($scope.review.tos_consent == true && top <= 100) {
          $scope.acknowledge = true;
        }
      };

      $scope.storeAddress = $rootScope.ruiMethods.agent.storeAddress();

      $scope.review = {};
      $scope.review.submitted = false;
      $scope.review.submitting = false;
      $scope.orderSummary = orderSummary;

      $scope.forms.review.isTouched = true;
      buyService.saveSession('profile', $scope.forms);

      $scope.review.tier = cartManager.internet.tierInCart();
      $scope.review.language = buyUtils.getAppLang();
      angular.extend($scope.orderSummary, { currentDate: moment() });
      $scope.promoOfferId = $rootScope.promoOfferId ? $rootScope.promoOfferId : null;
      $scope.review.promoOfferId = $rootScope.promoOfferId ? $rootScope.promoOfferId : null;
      $scope.discountOffers = $rootScope.discountOffers ? $rootScope.discountOffers : null;
      $scope.review.discountOffers = $rootScope.discountOffers ? $rootScope.discountOffers : null;
      //FUSS-1523 & FUSS-1516 setting fulfillment & payment option - Step 5 DTM tracking
      if ($scope.review.tier) {
        if ($scope.review.tier.selectedOffer && $scope.review.tier.selectedOffer.offerPrice) {
          dtmService.setVar(
            dtmServiceConstants.dtmRules.buyInternet.selectedProduct,
            $scope.review.tier.selectedOffer.offerId
          );
          dtmService.setVar(
            dtmServiceConstants.dtmRules.buyInternet.productPrice,
            $scope.review.tier.selectedOffer.offerPrice.price
          );
        }
        if ($scope.forms) {
          if (
            $scope.forms.fulfillment &&
            $scope.forms.fulfillment.selectedOption &&
            $scope.forms.paymentOptions &&
            $scope.forms.paymentOptions.selectedPaymentOption
          ) {
            switch ($scope.forms.fulfillment.selectedOption) {
              case 'shipToAddress':
                dtmService.setVar(
                  dtmServiceConstants.dtmRules.buyInternet.review.fulfillmentParamName,
                  dtmServiceConstants.dtmRules.buyInternet.review.shipToAddress
                );
                break;
              case 'pickupAtStore':
                dtmService.setVar(
                  dtmServiceConstants.dtmRules.buyInternet.review.fulfillmentParamName,
                  dtmServiceConstants.dtmRules.buyInternet.review.pickupAtStore
                );
                break;
              case 'techInstall':
                dtmService.setVar(
                  dtmServiceConstants.dtmRules.buyInternet.review.fulfillmentParamName,
                  dtmServiceConstants.dtmRules.buyInternet.review.techInstall
                );
                break;
              case 'takeItWithYou':
                dtmService.setVar(
                  dtmServiceConstants.dtmRules.buyInternet.review.fulfillmentParamName,
                  dtmServiceConstants.dtmRules.buyInternet.review.takeItWithYou
                );
                break;
              default:
            }
            dtmService.setVar(
              dtmServiceConstants.dtmRules.buyInternet.review.paymentParamName,
              $scope.forms.paymentOptions.selectedPaymentOption
            );
            dtmService.direct(dtmServiceConstants.dtmRules.buyInternet.review.ruleName);
          }
        }
        /* DSO-15392 start */
        if (
          $scope.promoOfferId === null ||
          ($scope.review.promoOfferId === null && $scope.discountOffers === null) ||
          $scope.review.discountOffers === null
        ) {
          if (
            commonService.customerHasInternetService &&
            commonService.internetAccountStatus !== 'SUSPENDED' &&
            commonService.internetAccountStatus !== 'CANCELLED'
          ) {
            $scope.promoOfferId = null;
            $scope.review.promoOfferId = null;
          } else {
            //$timeout(function(){
            var isOfferIdEligible = buyService.isPromoOfferIdEligible($scope.review.tier.selectedOffer.offerId);
            if (isOfferIdEligible === null) {
              buyService.getInternetPromos().then(function(data) {
                if (data) {
                  isOfferIdEligible = buyService.isPromoOfferIdEligible($scope.review.tier.selectedOffer.offerId);
                  $scope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                  $scope.review.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                  $scope.discountOffers = buyService.getDiscountOffers();
                  $scope.review.discountOffers = buyService.getDiscountOffers();
                }
              });
            } else {
              $scope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
              $scope.review.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
              $scope.discountOffers = buyService.getDiscountOffers();
              $scope.review.discountOffers = buyService.getDiscountOffers();
            }
            $rootScope.promoOfferId = $scope.promoOfferId;
            $rootScope.discountOffers = $scope.discountOffers;
            //},0);
          }
        }
        if (
          $rootScope.discountOffers === null ||
          ($scope.review.discountOffers === null && !$rootScope.ruiMethods.user.is.loggedIn())
        ) {
          buyService.getInternetPromos().then(function(data) {
            var response = data;
            $rootScope.discountOffers = response;
            $scope.review.discountOffers = response;
          });
        }
        /* DSO-15392 end */
      }
      var rts = angular.copy($rootScope.shoppingCart);
      if (
        orderSummary &&
        orderSummary.orderSummaryTotal &&
        orderSummary.orderSummaryTotal.monthly &&
        (orderSummary.orderSummaryTotal.monthly.tax ||
          orderSummary.orderSummaryTotal.monthly.total ||
          orderSummary.orderSummaryTotal.monthly.offerTotal)
      ) {
        cartManager
          .addMeta({
            total: {
              tax: orderSummary.orderSummaryTotal.monthly.tax,
              grand: orderSummary.orderSummaryTotal.monthly.total,
              sub: orderSummary.orderSummaryTotal.monthly.offerTotal
            }
          })
          .then(function() {
            console.log(rts);
            console.log('@buyReview:cartManager.addMeta: ($rootScope.shoppingCart) ', $rootScope.shoppingCart);
            buyService.shoppingCartCached = angular.copy($scope.review.tier);
            console.log('@buyReviewCtrl (cartCached) ', buyService.shoppingCartCached);
            console.log('@buyReviewCtrl ($scope) ', $scope);
          });
      }

      $scope.getCCCardType = buyUtils.getCCType().byFirstChar;
      $scope.getCCMaskedToken = uteSemafoneService.getMaskedToken;

      $scope.internetPackageInfoMixins = {
        editCheckout: $rootScope.ruiMethods.user.is.agent()
          ? function() {
              $scope.selectedOffer = JSON.parse(window.sessionStorage.getItem('agentSelectedOffer'));
              var params = {},
                endpoint = brtEndpoint('v2/internetOffers');
              params.province = uteLocale.province;
              params.userId = $rootScope.atg && $rootScope.atg.userId && $rootScope.atg.userId.value;
              params.hashKey = $rootScope.atg && $rootScope.atg.hashKey && $rootScope.atg.hashKey.value;
              //params.samKey = brtSwitchCMS.brtSwitch && brtSwitchCMS.brtSwitch.fetchAddressBasedOffers ? self.samKey : 'default';
              params.samKey = 'default';
              internetPackageService.getInternetPackage(endpoint, params).then(function(result) {
                const internetPackages = result.data.internetPackages;
                if (
                  internetPackages &&
                  internetPackages[uteLocale.language] &&
                  internetPackages[uteLocale.language].tier &&
                  internetPackages[uteLocale.language].tier.length > 0
                ) {
                  $scope.internetPackage = internetPackages[uteLocale.language].tier;
                }

                $scope.result = result.data;
                $scope.modalInstance = uteModal.open({
                  templateUrl: 'modules/checkout/views/edit-package.html',
                  size: 'lg',
                  scope: $scope
                  // controller: 'buyReviewCtrl'
                });
              });
            }
          : $scope.buyMethods.editCheckout
      };

      $scope.updateCart = function(tier) {
        console.log('before update', cartManager.internet.tierInCart());
        cartManager.internet.addOffer(tier, tier.products[0].offers[0].offerId).then(function() {
          console.log('after update', cartManager.internet.tierInCart());
          var session = sessionStorage.getItem('profile');
          var data = angular.fromJson(session);
          $scope.review.tier = cartManager.internet.tierInCart();
          $scope.orderSummary = cartManager.internet.getCartSummary(data.fulfillment.selectedOption === 'techInstall');
          $scope.modalInstance.close();

          var updatePackage = {
            events: {
              addToCart: true
            },
            ecommerce: {
              products: [
                {
                  id: tier.products[0].offers[0].offerId,
                  category: 'internet',
                  name: tier.products[0].offers[0].name,
                  subCategory: 'package'
                }
              ]
            }
          };

          dataLayerService.track(updatePackage, false, [0, 1, 4]);
          // dataLayerService.track(updatePackage, false, [DataLayerPredefinedSection.PAGE,
          //   DataLayerPredefinedSection.SITE]);

          // dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'onboarding.onboardingCompleted'});
          // dataLayerService.getMappingPayload({mappingKey: 'updatePackage'});
          // _dataLayerService.getMappingPayload({mappingKey: stateName + '-' + key})
        });
      };
      $scope.editCheckout = $scope.buyMethods.editCheckout;

      $scope.getTimeFormat = buyUtils.getTimeFormat;

      $scope.submitReview = function() {
        if ($scope.review.tos_consent && $scope.acknowledge && $scope.clicked) {
          $scope.review.submitting = true;
          buyService.submitOrder().then(
            function(res) {
              $scope.review.submitting = false;

              buyService.saveSession('confirmation', res);

              $scope.completedForm($state.current.name);
            },
            function() {
              $scope.review.submitting = false;
              _satellite.setVar('error', 'FHSI | review submitting failed');
              _satellite.track('bfa-fhsi-error');
            }
          );
        } else {
          $scope.review.submitted = true;
          $timeout(function() {
            var errorList = document.getElementsByClassName('ute-message error');
            if (errorList.length > 0 && errorList[0].getClientRects().length > 0) {
              //errorList[0].parentElement.scrollIntoView();
              var yPos = errorList[0].getClientRects()[0].top;
              var scrollValue =
                yPos -
                document.getElementsByClassName('create-profile-menu-holder')[0].offsetHeight -
                document.getElementById('header').offsetHeight -
                135;
              window.scrollBy(0, scrollValue);
            }
          });
        }
      };
    }
  ]);
})();
